import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  ReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "salesOrderCancelReport",
  templateUrl: "./salesOrderCancelReport.html",
})
export class salesOrderCancelReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  // @Output() tabUpdateEvent = new EventEmitter();
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  gridOptions: any;
  data: any;
  typeList = ["Partywise", "Agentwise", "Prepared By", "Scanned By", "Stylewise"];
  exceldata: any;
  menu : any;
  curDate = new Date();
  fitList = [];
  seasonList = [];
  finyearList = [];
  seasonfinList = [];
  listSelected: any = [];
  brandList = ["EXPOSE", "ARAZA", "GREEN OLIVE", "LEO BOYS", "JOB", "ALL"];
  orderPenArr: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  user: any;
  designData: any;
  SalesCancelOrder: any;
  newlistSelected = [];
  partyList = [];
  agentVisible: boolean = false;
  clear: boolean = false;
  total_ord: number = 0;
  total_dlry: number = 0;
  total_pend: number = 0;
  filter = {
    party_id: "",
    from_date: "",
    to_date: "",
    newDesignShade: "",
    shade: "",
    groupby: "party_wise",
    group: "",
    type: "party_wise",
    so_date: "",
    so_no: "",
    party_name: "",
    so_id: ""
  };
  dispName = [];
  screen_from = ""
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderby: "party_wise",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Party Yearly report",
    columns: [],
    rows: [],
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    name: "",
  };

  constructor(
    public store: Store<fromRootStore.State>,
    private reportService: ReportService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private combo: Combo2Service,
    public comboservice: ComboService
  ) {
    let from_date =
      this.curDate.getFullYear() +
      "-" +
      this.curDate.getMonth() +
      "-" +
      this.curDate.getDate(),
      to_date =
        this.curDate.getFullYear() +
        "-" +
        (this.curDate.getMonth() + 1) +
        "-" +
        this.curDate.getDate();

    this.filter.from_date = this.datePipe.transform(to_date, "yyyy-MM-dd");
    this.filter.to_date = this.datePipe.transform(to_date, "yyyy-MM-dd");
  }

  ngOnInit(): void {
    this.getPartyList();
    this.getSalesColumn();
    this.getSalesOrderCancelReport();
  }


  onOpenedFilter(): void { }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getSalesOrderCancelReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  setData(data) {
    this.data = Object.assign({}, data);
  }


  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "applyFilter") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      this.applyFilter();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSalesOrderCancelReport();
  }

  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderby = sortInfo.sorts[0].prop;
    this.getSalesOrderCancelReport();
  }

  onDesignClick(event) {
    let row = event.row;
    if (this.filter.type == 'party_wise') {
      this.filter.party_id = row.party_id;
      this.filter.party_name = row.party_name;
      this.filter.type = 'design';
    } else if (this.filter.type == 'design') {
      this.filter.type = 'designColor';
      this.filter.newDesignShade = row.design_no;
      this.filter.so_id = row.so_id;
      this.filter.so_date = row.so_date;
      this.filter.so_no = row.so_no;
    }

    // else if (this.filter.type == 'designColor') {
    //   this.filter.so_id = row.so_id;
    // }
    this.getSalesOrderCancelReport();
  }

  onbackbutton() {
    if (this.filter.type == "designColor") {
      this.filter.type = "design";
      this.filter.so_id = "";
      this.filter.newDesignShade = "";
      this.filter.so_date = "";
      this.filter.so_no = "";
    } else if (this.filter.type == "design") {
      this.filter.type = "party_wise";
      this.filter.party_name = "";
      this.filter.party_id = "";
    }
    // else if (this.filter.type == "party_wise") {
    //   this.filter.party_name = "";
    // }
    this.getSalesOrderCancelReport();
  }

  getSalesColumn() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      maxHeight: window.innerHeight - 460 + "px",
      loading: true,
      data: [],
      screenName: 'salesOrdercancelReport'
    };
    this.designData = {
      cols: [],
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

  }
  // totSo() {
  //   let that = this;
  //   that.total_ord = 0;
  //   that.total_dlry = 0;
  //   that.total_pend = 0;
  //   that.SalesCancelOrder.forEach((el) => {
  //     that.total_ord += Number(el.ord_pcs);
  //     that.total_dlry += Number(el.dlry_pcs);
  //     that.total_pend += Number(el.tot);
  //     el.ord_pcs = el.ord_pcs;
  //   });
  //   that.total_ord =
  //     Math.round(((that.total_ord + Number.EPSILON) * 100) / 100);
  // }

  onClickColor(event) {
    let tabObj = {};
    this.clear = true;
    let chkData = this.clear;
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ORDER_REPORTS",
        title: "ORDER REPORT",
        tabParent: "REPORTS",
        data: event.row,
        chkData: chkData,
        name: "DesignWiseSalesOrderReport",
      },
    };

    // this.tabUpdateEvent.emit(tabObj);
  }

  getSalesOrderCancelReport(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderby}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      dispName: JSON.stringify(this.dispName),
      screenType :  this.menu.param == 'Counter' ? 'counterReport' : this.menu.param == 'CounterInward' ? 'InwardReport' : ''
    };
    let that = this;
    // that.gridOptions = {
    //   loading: true,
    //   columns: [],
    //   screenName: "salesOrdercancelReport"
    // };
    this.isLoadMask = this.reportService
      .getSalesOrderCancelReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.orderPenArr = res.data;
        that.columns = res.columns;
        that.gridOptions = {
          columns: res.columns,
          cols: res.cols,
          data: res.data,
          loading: false,
          screenName: 'salesOrdercancelReport'
        };

        that.designData = {
          cols: res.cols,
          data: res.data,
        };
        that.page.count = res.total;
        that.refreshData();
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearbtn(){
    this.filter.type = "party_wise";
    this.filter.party_id = "";
    this.filter.party_name = "";
    this.filter.group = "";
    this.getSalesOrderCancelReport();
  }

  applyFilter(): void {
    this.filter.type = "party_wise";
    this.getSalesOrderCancelReport();
  }

  onRowSelected($event) {
    let data = Object.assign($event.selected[0]);
    const tabObj = {
      action: "NewTab",
      params: {
        tabParent: "REPORTS",
        tabName: "PartySalesOrderReport",
        type: "order",
        mode: "View",
        data: data,
      },
    };
    // this.tabUpdateEvent.emit(tabObj);
  }

  refreshData() {
    let columns = this.columns,
      data = this.orderPenArr;
    this.page.count = data.length;
  }

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  onSelectParty(party) {
    this.partyList.forEach((element) => {
      if (party == element.name) {
        this.filter.party_id = element.genLedid;
      }
    });

    this.orderPenArr = this.orderPenArr.filter(e => e.party_id == this.filter.party_id);
    // this.totSo();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesOrderCancel/salesOrderCancelReport.ts